exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".market-price-detail-modal-table tbody tr[data-v-33a68474]:last-child{border-bottom:1px solid #000}", ""]);

// exports
